<template>
    <div>
        <Molded :paddingLeft="16" :paddingRight="16">
            <ItemReconciliation :item="editableItem" :isNew="true" :disabledBankAccount="true" />
        </Molded>
        <div class="create-from-statement-modal-alert" v-if="!hasBankAccount">
            <Alert type="warning">
                Este item do extrato não possui conta bancária vinculada. Reimporte o extrato informando a conta
                bancária para poder criar o lançamento.
            </Alert>
        </div>
        <div class="create-from-statement-modal-actions text-center">
            <Button _key="btnCreateFromStatement" title="Conciliar lançamento" size="medium" type="primary"
                :disabled="!hasBankAccount" :clicked="save" />
            <Button title="Cancelar" size="medium" type="danger" :clicked="() => hideModal()" />
        </div>
    </div>
</template>
<script>

import Molded from "@/ui/layout/Molded";
import Alert from "@/ui/layout/Alert";
import Button from "@/ui/forms/Button";

import ItemReconciliation from './ItemReconciliation.vue'
import BankReconciliationService from "../../services/bankReconciliation.service";

import { mapActions, mapMutations } from "vuex";

export default {
    name: "CreateFromStatementModal",
    components: { Molded, Alert, Button, ItemReconciliation },
    props: {
        statementItem: Object,
    },
    data() {
        return {
            editableItem: {
                id: this.statementItem.id,
                type: this.statementItem.type,
                dueDate: this.statementItem.dueDate,
                value: this.statementItem.value,
                description: this.statementItem.description,
                recipient: {},
                rent: {},
                chartOfAccounts: {},
                typePayment: {},
                bankAccount: (this.statementItem.bankAccount && this.statementItem.bankAccount.id)
                    ? { ...this.statementItem.bankAccount }
                    : {},
            },
        };
    },
    computed: {
        hasBankAccount() {
            return !!(this.editableItem.bankAccount && this.editableItem.bankAccount.id);
        },
    },
    methods: {
        ...mapActions("generic", ["postApi"]),
        ...mapMutations("generic", ["addEvent", "hideModal", "removeLoading"]),
        save() {
            let params = {
                url: BankReconciliationService.urlCreatePayableReceivable,
                obj: {
                    statementId: this.statementItem.id,
                    recipient: this.editableItem.recipient,
                    description: this.editableItem.description,
                    rent: this.editableItem.rent,
                    chartOfAccounts: this.editableItem.chartOfAccounts,
                    typePayment: this.editableItem.typePayment,
                    bankAccount: this.editableItem.bankAccount,
                },
                notNotifyToast: true,
            };
            this.postApi(params).then((response) => {
                if (response.success) {
                    this.hideModal();
                    this.addEvent({ name: "createFromStatementExecuted", data: { statementId: this.statementItem.id } });
                }
                this.removeLoading(["btnCreateFromStatement"]);
            });
        },
    },
};
</script>
<style scoped>
.create-from-statement-modal-alert {
    margin-top: 12px;
}

.create-from-statement-modal-actions {
    margin-top: 10px;
}
</style>
